import { Button } from "components/Button/Button";
import { formatDate } from "utils/formatting";
import './CourseLock.scss';

const CourseLock = ({ locked, data, handleLockToggle }) => {
	return (
		<div className="course-lock">
			<h1>Course Lock Control</h1>
			{locked.hasTimestamp ? (
				<p>
					Course locked by {data.LockUsername} at{" "}
					{formatDate(data.LockTimestamp, true)}
				</p>
			) : (
				<p>Courses must be locked to be editable.</p>
			)}
			<div className="course-lock-buttons">
				<Button
					text={locked.hasTimestamp ? "Unlock" : "Lock for Editing"}
					disabled={locked.hasTimestamp && !locked.byCurrentUser}
					onClick={handleLockToggle}
				/>
			</div>
		</div>
	);
};

export default CourseLock;
